import React, { useEffect, useState } from "react";
import "./SkinAssessmentHeader.scss";
import SquareFloatButton from "../../../../../common/squareFloatButton/SquareFloatButton";
import HnwHomeButton from "../../../../../common/hnwHomeButton/HnwHomeButton";
import { SKIN_ASSESS_IMG } from "../../../../../common/homePageConstants";
import { commonConstant } from "../../../../../common";
import { useHistory } from "react-router-dom";
import { getCartDetail } from "../../../../../actions";
import { SESSION_KEY } from "../../../../../common/commonConstant";
import { useDispatch } from "react-redux";

const SkinAssessmentHeader = ({ headerAction, showHomeButton = true }) => {

    const history = useHistory();
    const dispatch = useDispatch();
    const [cartCount, setCartCount] = useState(0);

    useEffect(() => {
        const didMount = async () => {
            await getCartData();
        }
        didMount();
    }, [headerAction]);

    const getCartData = async () => {
        try {
            dispatch(getCartDetail('FULL')).then((cart) => {
                sessionStorage.setItem(SESSION_KEY.pifCartId, cart.cartId);
                if (cart && cart.entries) {
                    const count = cart.entries.reduce((total, item) =>
                        total + (item.kitEntryCode || item.isGiveAway ? 0 : item.quantity || 0),
                        0,
                    );
                    setCartCount(count);
                }
            });
        } catch (error) {
            throw new Error(error);
        }
    }

    const handleCart = () => {
        history.push(commonConstant.pathCartPromotion);
    }

    return (
        <div className="skin-assessment-header">
            <img src={SKIN_ASSESS_IMG.headerBgUrl} className="w-100 header-curve-bg" />
            <div className="skin-assessment-header-overlay">
                {showHomeButton && <HnwHomeButton />}
                <div className="skin-assessment-header-overlay-logo">
                    <img src={SKIN_ASSESS_IMG.headerImgUrl} className="skin-assessment-header-overlay-logo-img" />
                </div>
                <div className="skin-assessment-header-overlay-cart-icon" onClick={() => handleCart()}>
                    <SquareFloatButton className="home-square-float-btn">
                        <img src={SKIN_ASSESS_IMG.cartIconUrl} />
                        {cartCount > 0 && (<span className="circle-notification">
                        </span>)}
                    </SquareFloatButton>
                </div>
            </div>
        </div>
    )
}

export default SkinAssessmentHeader;